import React from 'react';
import DOMPurify from 'dompurify';
import Search from './Search';
import LoadMoreButton from './LoadMoreButton';
import JobList from './JobList';
import NoJobs from './NoJobs';
import { countryList } from '../data/country-list';
import './../scss/App.scss';
// api calls
import unique_data from '../api/unique_data.js';
import jobstreamurl from '../api/jobs.js';
import axios from 'axios';

const { __, getLocaleData } = window.wp.i18n;

class App extends React.Component {
  state = {
    keyword: '',
    searched: false,
    jobs: [],
    jobstreamurl: '',
    countries: [],
    experience_level: [],
    department: [],
    contract_type: [],
    business_units: [],
    uniquevalues: [],
    locations: [],
    professional_communities: [],
    brand: [],
    size: 15,
    isErrored: false,
    originalSearchQuery: ''
  };

  ArrayCreateValueLabelCountry (val) {
    const pre_defined_country_list = countryList;
    const countryListItem = pre_defined_country_list.find((element) => element.key === val);
    return {
      value: countryListItem ? countryListItem?.key : val,
      label: countryListItem ? countryListItem.value : ''
    };
  }

  async componentDidMount () {
    const regex = new RegExp('^#([^=]+=[^=]+&)?[^=]+(=[^=]+)+$');
    const hash = window.location.hash;
    if (regex.test(hash)) {
      const queryString = hash.replace('#', '?');
      window.location.replace(`${DOMPurify.sanitize(window.location.origin)}${DOMPurify.sanitize(window.location.pathname)}${queryString}`);
    } else {
      // saving the original search
      const urlSearch = window.location.search;
      this.setState({
        originalSearchQuery: urlSearch
      }, async () => {
        const jobSearchParams = this.getJobSearchParamsFromURL();
        const queryStringData = {
          keyword: jobSearchParams.keyword,
          country_code: jobSearchParams.countryCode,
          country_name: jobSearchParams.countryName,
          experience_level: jobSearchParams.experienceLevel,
          department: jobSearchParams.department,
          contract_type: jobSearchParams.contractType,
          sbu: jobSearchParams.sbu,
          location: jobSearchParams.location,
          professional_communities: jobSearchParams.professionalCommunities,
          brand: jobSearchParams.brand,
          size: jobSearchParams.size
        };

        // running it in timeout for piano sdk to load
        window.addEventListener('load', () => {
          try {
            const page = queryStringData?.size ? Number(queryStringData.size) / 15 : 1;
            if (jobSearchParams.keyword) {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: 'internal_search_result.display',
                ise_keyword: jobSearchParams.keyword,
                ise_page: page,
                ise_engine: 'job_search'
              });
            }
          } catch (e) {
            console.log(e);
          }
        });

        await this.fetchAllData(queryStringData);

        this.setState({
          jobstreamurl: ''
        });

        if (jobSearchParams.keyword) {
          document.getElementById('anchor').scrollIntoView();
        }
      });
    }
  }

  /**
     *
     * @return {{experienceLevel: (string|string), size: (string|number), countryCode: (string|string), contractType: (string|string), sbu: (string|string), location: (string|string), countryName: (string|string), professionalCommunities: (string|string), keyword: (string|string), department: (string|string), brand: (string|string)}}
     */
  getJobSearchParamsFromURL = () => {
    const urlParams = new URLSearchParams(window.location.search); // phpcs:ignore

    return {
      keyword: urlParams.has('keyword') ? urlParams.get('keyword') : '',
      countryCode: urlParams.has('country_code') ? urlParams.get('country_code') : '',
      countryName: urlParams.has('country_name') ? urlParams.get('country_name') : '',
      experienceLevel: urlParams.has('experience_level') ? urlParams.get('experience_level') : '',
      department: urlParams.has('department') ? urlParams.get('department') : '',
      contractType: urlParams.has('contract_type') ? urlParams.get('contract_type') : '',
      sbu: urlParams.has('sbu') ? urlParams.get('sbu') : '',
      location: urlParams.has('location') ? urlParams.get('location') : '',
      professionalCommunities: urlParams.has('professional_communities') ? urlParams.get('professional_communities') : '',
      brand: urlParams.has('brand') ? urlParams.get('brand') : '',
      size: urlParams.has('size') ? urlParams.get('size') : '15'
    };
  };

  getUtmCampaignParamsFromSearch = () => {
    const urlParams = new URLSearchParams(this.state.originalSearchQuery);
    const utmCampaignObject = {
      utm_source: urlParams.has('utm_source') ? urlParams.get('utm_source') : null,
      utm_medium: urlParams.has('utm_medium') ? urlParams.get('utm_medium') : null,
      utm_campaign: urlParams.has('utm_campaign') ? urlParams.get('utm_campaign') : null
    };
    return utmCampaignObject;
  };

  getHashValue (key) {
    const matches = window.location.hash.match(new RegExp(key + '=([^&]*)'));// phpcs:ignore WordPressVIPMinimum.JS.Window.VarAssignment
    return matches ? decodeURIComponent(matches[1]) : null;
  }

  // removeParam (paramName) {
  //   const searchParams = new URLSearchParams(window.location.search)// phpcs:ignore
  //   searchParams.delete(paramName)
  //   if (window.history.replaceState) {
  //     const searchString = searchParams.toString().length > 0 ? '?' + searchParams.toString() : ''
  //     const newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + searchString + window.location.hash// phpcs:ignore
  //     window.history.replaceState(null, '', newUrl)
  //   }
  // }

  getHashQuery (keyword, countryCode, countryName, experience_level, department, contract_type, business_units, locations, brand, professional_communities, size) {
    const pathName = `${window.es_var.pathName}`;
    if (pathName && !countryCode) {
      countryCode = pathName;
    }
    const country_label = this.ArrayCreateValueLabelCountry(countryCode);
    countryName = country_label.label;

    const queryArgs = {
      keyword,
      country_code: countryCode,
      country_name: countryName,
      experience_level,
      department,
      contract_type,
      sbu: business_units,
      location: locations,
      professional_communities,
      brand,
      size
    };
    const utmCampaignObject = this.getUtmCampaignParamsFromSearch();
    console.log(utmCampaignObject);
    if (utmCampaignObject.utm_campaign || utmCampaignObject.utm_medium || utmCampaignObject.utm_source) {
      const utmSearchParams = new URLSearchParams(utmCampaignObject);
      return this.encodeQueryData(queryArgs) + '&' + utmSearchParams.toString();
    } else {
      return this.encodeQueryData(queryArgs);
    }
  }

  getQueryAPI (keyword, countryCode, countryName, experience_level, department, contract_type, business_units, locations, brand, professional_communities, size) {
    const pathName = `${window.es_var.pathName}`;
    if (pathName && !countryCode) {
      countryCode = pathName;
    }
    const country_label = this.ArrayCreateValueLabelCountry(countryCode);
    countryName = country_label.label;
    const queryArgs = {
      query: keyword,
      country: countryCode,
      country_name: countryName,
      experience_level,
      department,
      contract_type,
      sbu: business_units,
      location: locations,
      professional_communities,
      brand,
      size
    };
    return this.encodeQueryData(queryArgs);
  }

  encodeQueryData (data) {
    const ret = [];
    for (const d in data) {
      if (encodeURIComponent(data[d]) && encodeURIComponent(data[d]) != 'undefined' && encodeURIComponent(data[d]) != 'null') { ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d])); }
    }
    return ret.join('&');
  }

  getQuery (keyword, countryCode, countryName, experience_level, department, contract_type, business_units, locations, brand, professional_communities) {
    const pathName = `${window.es_var.pathName}`;
    if (pathName && !countryCode) {
      countryCode = pathName;
    }
    const country_label = this.ArrayCreateValueLabelCountry(countryCode);
    countryName = country_label.label;
    const queryArgs = {
      keyword,
      country_code: countryCode,
      country_name: countryName,
      experience_level,
      department,
      contract_type,
      sbu: business_units,
      location: locations,
      professional_communities,
      brand
    };

    let key;
    const query = [];

    for (key in queryArgs) {
      if (encodeURIComponent(queryArgs[key]) && encodeURIComponent(queryArgs[key]) != 'undefined' && encodeURIComponent(queryArgs[key]) != 'null') {
        // Exclude undefined parameters
        if ((Object.hasOwn(queryArgs, key) && typeof (queryArgs[key]) === 'undefined') || (queryArgs[key] === '')) {
          delete queryArgs[key];
        } else if (key === 'keyword') {
          query.push(queryArgs[key]);
        } else {
          // Add existing params to array
          query.push(key + ':' + queryArgs[key]);
        }
      }
    }

    // Build query string
    return query.join(' AND ');
  }

  fetchJobstreamUrl = async (queryStringData) => {
    this.setState({
      jobstreamurl: ''
    },
    this.fetchAllData(queryStringData)
    );
  };

  fetchJobs = async (keyword, countryCode, countryName, experience_level, department, contract_type, business_units, locations, brand, professional_communities, size) => {
    const pathName = `${window.es_var.pathName}`;
    const country_codes_param = `${window.es_var.country_codes_param}`;
    if (pathName && !countryCode) {
      countryCode = pathName;
      if (pathName === 'ca-fr') {
        countryCode += ',ca-en';
      }
    }

    if (document.getElementById('hidden_keyword') !== undefined && document.getElementById('hidden_keyword') !== null) {
      const hidden_keyword = document.getElementById('hidden_keyword').value;

      if (hidden_keyword !== undefined && hidden_keyword !== '') {
        if (this.state.searched === false) {
          keyword = hidden_keyword;
        }
      }
    }
    let sizevalue = this.state.size;
    if (size) {
      sizevalue = size;
    }
    const query = this.getQueryAPI(keyword, countryCode, countryName, experience_level, department, contract_type, business_units, locations, brand, professional_communities, sizevalue);
    const getHashQuery = this.getHashQuery(keyword, countryCode, countryName, experience_level, department, contract_type, business_units, locations, brand, professional_communities, sizevalue);
    window.history.pushState(null, '', '?' + getHashQuery);
    const domainName = window.location.hostname;
    let sogetiBrandQuery = '';
    if (domainName.includes('sogeti')) {
      sogetiBrandQuery = 'brand=Sogeti&';
      if (country_codes_param) {
        sogetiBrandQuery += 'country=' + country_codes_param + '&';
      }
    }

    try {
      // 2xx
      const response = await axios.get('/wp-json/macs/v1/jobs?' + sogetiBrandQuery + query);
      this.setState({
        jobs: (response?.data && typeof response?.data === 'object') ? response.data : null,
        keyword,
        countryCode,
        countryName,
        experience_level,
        department,
        contract_type,
        business_units,
        locations,
        professional_communities,
        brand,
        searched: true,
        size: sizevalue
      },
      this.scrollToResults
      );
    } catch (e) {
      this.setState({
        isErrored: true
      });
    }
  };

  loadMore = async (size, keyword, countryCode, countryName, experience_level, department, contract_type, business_units, locations, brand, professional_communities) => {
    size.preventDefault();
    if (this.state.keyword !== '') {
      keyword = this.state.keyword;
    }
    const pathName = `${window.es_var.pathName}`;
    const country_codes_param = `${window.es_var.country_codes_param}`;
    if (pathName && !countryCode) {
      countryCode = pathName;
    }
    size = (Number(this.state.size) + Number(15));
    const query = this.getQueryAPI(this.state.keyword, this.state.countryCode, this.state.countryName, this.state.experience_level, this.state.department, this.state.contract_type, this.state.business_units, this.state.locations, this.state.brand, this.state.professional_communities, size);

    const getHashQuery = this.getHashQuery(this.state.keyword, this.state.countryCode, this.state.countryName, this.state.experience_level, this.state.department, this.state.contract_type, this.state.business_units, this.state.locations, this.state.brand, this.state.professional_communities, size);
    window.history.pushState(null, '', '?' + getHashQuery);

    const domainName = window.location.hostname;
    let sogetiBrandQuery = '';
    if (domainName.includes('sogeti')) {
      sogetiBrandQuery = 'brand=Sogeti&';
      if (country_codes_param) {
        sogetiBrandQuery += 'country=' + country_codes_param + '&';
      }
    }

    const more = await axios.get('/wp-json/macs/v1/jobs?' + sogetiBrandQuery + query).then(more =>
      this.setState({
        size: (Number(this.state.size) + Number(15)),
        jobs: more.data,
        keyword: this.state.keyword,
        countryCode: this.state.countryCode,
        countryName: this.state.countryName,
        experience_level: this.state.experience_level,
        department: this.state.department,
        contract_type: this.state.contract_type,
        business_units: this.state.business_units,
        locations: this.state.locations,
        professional_communities: this.state.professional_communities,
        brand: this.state.brand
      }, () => {
        try {
          const size = Number(this.state.size);
          const page = size ? Number(size) / 15 : 1;
          if (this.state.keyword) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'internal_search_result.display',
              ise_keyword: this.state.keyword,
              ise_page: page,
              ise_engine: 'job_search'
            });
          }
        } catch (e) {
          console.log(e);
        }
      })
    );
  };

  fetchUniqueData = async () => {
    const domainName = window.location.hostname;
    const country_codes_param = `${window.es_var.country_codes_param}`;
    let sogetiBrandQuery = '';
    if (domainName.includes('sogeti')) {
      sogetiBrandQuery = '?brand=Sogeti';
    }

    const pathName = window.es_var.pathName;
    const UniqueDataList = await unique_data.get(`/${pathName + country_codes_param + sogetiBrandQuery}`);
    const UniqueDataListExtra = pathName === 'ca-fr' ? await unique_data.get('/ca-en') : null;

    const tmp_country_code = [];
    const tmp_location = [];
    const tmp_experience_level = [];
    const tmp_department = [];
    const tmp_contract_type = [];
    const tmp_sbu = [];
    const tmp_professional_communities = [];
    const tmp_brand = [];

    const pre_defined_country_list = countryList;

    let final_country_list = new Map();
    const final_location_list = new Set();
    const final_experience_list = new Set();
    const final_department_list = new Set();
    const final_contract_list = new Set();
    const final_sbu_list = new Set();
    const final_professional_list = new Set();
    const final_brand_list = new Set();

    const processData = (data) => {
      data.forEach(d => {
        if (!d.items) return;

        switch (d.type) {
          case 'country_code':
            d.items.forEach(record => {
              const map_details = pre_defined_country_list.find(temp => temp.key === record.key);
              if (map_details && !final_country_list.has(record.key) && !Array.from(final_country_list.values()).includes(map_details.value.trim())) {
                final_country_list.set(record.key, map_details.value.trim());
              }
            });
            break;

          case 'location':
            d.items.forEach(record => {
              record.key.split(',').forEach(location => final_location_list.add(location.trim()));
            });
            break;

          case 'experience_level':
            d.items.forEach(record => {
              record.key.split(',').forEach(experience => final_experience_list.add(experience.trim()));
            });
            break;

          case 'department':
            d.items.forEach(record => final_department_list.add(record.key.replace('&amp;', '&').trim()));
            break;

          case 'contract_type':
            d.items.forEach(record => {
              record.key.split(',').forEach(contract => final_contract_list.add(contract.trim()));
            });
            break;

          case 'sbu':
            d.items.forEach(record => final_sbu_list.add(record.key.trim()));
            break;

          case 'professional_communities':
            d.items.forEach(record => {
              record.key.split(',').forEach(professional => final_professional_list.add(professional.trim()));
            });
            break;

          case 'brand':
            d.items.forEach(record => final_brand_list.add(record.key.trim()));
            break;

          default:
            break;
        }
      });
    };

    if (UniqueDataList?.data) processData(UniqueDataList.data);
    if (UniqueDataListExtra?.data) processData(UniqueDataListExtra.data);

    const sortAndPush = (finalList, tmpList) => {
      Array.from(finalList).sort((a, b) => a.localeCompare(b)).forEach(value => tmpList.push({ value, label: value }));
    };

    final_country_list = new Map([...final_country_list].sort((a, b) => a[1].localeCompare(b[1])));
    final_country_list.forEach((label, value) => tmp_country_code.push({ value, label }));
    sortAndPush(final_location_list, tmp_location);
    sortAndPush(final_department_list, tmp_department);
    sortAndPush(final_contract_list, tmp_contract_type);
    sortAndPush(final_sbu_list, tmp_sbu);
    sortAndPush(final_professional_list, tmp_professional_communities);
    sortAndPush(final_brand_list, tmp_brand);

    const experience_numeric = [];
    let experience_alpha = [];

    Array.from(final_experience_list).forEach(experience => {
      if (!isNaN('+' + experience[0])) {
        experience_numeric.push({ value: experience, label: experience });
      } else {
        experience_alpha.push({ value: experience, label: experience });
      }
    });

    experience_numeric.sort((a, b) => parseInt(a.value.replace(/,/g, '')) - parseInt(b.value.replace(/,/g, '')));
    experience_alpha = Array.from(experience_alpha).sort((a, b) => a.value.localeCompare(b.value));
    tmp_experience_level.push(...experience_numeric, ...experience_alpha);

    if (pathName === 'ca-fr') {
      tmp_country_code.push({ value: 'ca-fr', label: 'Canada French' });
      tmp_country_code.push({ value: 'ca-en', label: 'Canada English' });
    } else if (pathName === 'fr-fr') {
      tmp_country_code.push({ value: 'fr-fr', label: 'France' });
      tmp_country_code.push({ value: 'tn-fr', label: 'Tunisia' });
    }

    this.setState({
      countries: tmp_country_code,
      location: tmp_location,
      experiencelevel: tmp_experience_level,
      departments: tmp_department,
      contracttype: tmp_contract_type,
      businessunits: tmp_sbu,
      professionalcommunities: tmp_professional_communities,
      brands: tmp_brand
    });
  };

  /*
  fetchUniqueData = async () => {
    const pathName = `${window.es_var.pathName}`;
    const UniqueDataList = await unique_data.get('/' + pathName, {});
    let UniqueDataListExtra = '';
    if (pathName === 'ca-fr') {
      UniqueDataListExtra = await unique_data.get('/ca-en', {});
    }

    const tmp_country_code = [];
    const tmp_experience_level = [];
    const tmp_experience_level1 = [];
    const tmp_experience_level2 = [];
    const tmp_department = [];
    const tmp_contract_type = [];
    const tmp_sbu = [];
    const tmp_professional_communities = [];
    const tmp_brand = [];
    const tmp_location = [];

    const pre_defined_country_list = countryList;

    const final_country_list = [];
    const unique_country_list = [];
    const final_loction_list = [];
    const final_experience_list = [];
    const final_department_list = [];
    const final_contract_list = [];
    const final_sbu_list = [];
    const final_professional_list = [];
    const final_brand_list = [];

    if (UniqueDataList?.data && Array.isArray(UniqueDataList.data) && UniqueDataList?.data.length > 0) {
      UniqueDataList.data.map(function (d) {
        if (d.type === 'country_code') {
          const v1 = d.items;

          if (v1 !== undefined && v1 !== null) {
            v1.map(function (record) {
              if (record.key) {
                const map_details = pre_defined_country_list.filter(temp => (temp.key === record.key));

                const t = map_details.map(function (i) {
                  return i.value;
                });

                if (t[0]) {
                  if (!final_country_list.includes(record.key) && !unique_country_list.includes(t[0].trim())) {
                    final_country_list.push({ value: record.key, label: t[0].trim() });
                    unique_country_list.push(t[0].trim());
                  }
                  // tmp_country_code.push({value : record.key, label : t, job_count : record.doc_count});
                }
              }
            });
          }
        }

        if (d.type === 'location') {
          if (d.items !== undefined && d.items !== null) {
            d.items.map(function (record) {
              if (record.key) {
                const location_list = record.key.split(',');
                location_list.map(function (location) {
                  location = location.trim();
                  if (!final_loction_list.includes(location)) {
                    final_loction_list.push(location);
                  }
                });
              }
            });
          }
        }

        if (d.type === 'experience_level') {
          if (d.items !== undefined && d.items !== null) {
            d.items.map(function (record) {
              if (record.key) {
                const experience_list = record.key.split(',');
                experience_list.map(function (experience) {
                  experience = experience.trim();
                  if (!final_experience_list.includes(experience)) {
                    final_experience_list.push(experience);
                  }
                });
                // tmp_experience_level.push({value : record.key, label : record.key, job_count : record.doc_count});
              }
            });
          }
        }

        if (d.type === 'department') {
          if (d.items !== undefined && d.items !== null) {
            d.items.map(function (record) {
              if (record.key) {
                if (!final_department_list.includes(record.key.trim())) {
                  final_department_list.push(record.key.replace('&amp;', '&').trim());
                }
                // tmp_department.push({value : record.key, label : record.key, job_count : record.doc_count});
              }
            });
          }
        }

        if (d.type === 'contract_type') {
          if (d.items !== undefined && d.items !== null) {
            d.items.map(function (record) {
              if (record.key) {
                const contract_list = record.key.split(',');
                contract_list.map(function (contract) {
                  contract = contract.trim();
                  if (!final_contract_list.includes(contract)) {
                    final_contract_list.push(contract);
                  }
                });
                // tmp_contract_type.push({value : record.key, label : record.key, job_count : record.doc_count});
              }
            });
          }
        }

        if (d.type === 'sbu') {
          if (d.items !== undefined && d.items !== null) {
            d.items.map(function (record) {
              if (record.key) {
                if (!final_sbu_list.includes(record.key.trim())) {
                  final_sbu_list.push(record.key.trim());
                }
                // tmp_sbu.push({value : record.key, label : record.key, job_count : record.doc_count});
              }
            });
          }
        }

        if (d.type === 'professional_communities') {
          if (d.items !== undefined && d.items !== null) {
            d.items.map(function (record) {
              if (record.key) {
                const professional_list = record.key.split(',');
                professional_list.map(function (professional) {
                  professional = professional.trim();
                  if (!final_professional_list.includes(professional)) {
                    final_professional_list.push(professional);
                  }
                });
              }
            });
          }
        }

        if (d.type === 'brand') {
          if (d.items !== undefined && d.items !== null) {
            d.items.map(function (record) {
              if (record.key) {
                if (!final_brand_list.includes(record.key.trim())) {
                  final_brand_list.push(record.key.trim());
                }
                // tmp_sbu.push({value : record.key, label : record.key, job_count : record.doc_count});
              }
            });
          }
        }
      });
    }

    if (UniqueDataListExtra?.data && Array.isArray(UniqueDataListExtra.data) && UniqueDataListExtra.data.length > 0) {
      UniqueDataListExtra.data.map(function (d) {
        if (d.type === 'country_code') {
          const v1 = d.items;

          if (v1 !== undefined && v1 !== null) {
            v1.map(function (record) {
              if (record.key) {
                const map_details = pre_defined_country_list.filter(temp => (temp.key === record.key));

                const t = map_details.map(function (i) {
                  return i.value;
                });

                if (t[0]) {
                  if (!final_country_list.includes(record.key) && !unique_country_list.includes(t[0].trim())) {
                    final_country_list.push({ value: record.key, label: t[0].trim() });
                    unique_country_list.push(t[0].trim());
                  }
                  // tmp_country_code.push({value : record.key, label : t, job_count : record.doc_count});
                }
              }
            });
          }
        }

        if (d.type === 'location') {
          if (d.items !== undefined && d.items !== null) {
            d.items.map(function (record) {
              if (record.key) {
                const location_list = record.key.split(',');
                location_list.map(function (location) {
                  location = location.trim();
                  if (!final_loction_list.includes(location)) {
                    final_loction_list.push(location);
                  }
                });
              }
            });
          }
        }

        if (d.type === 'experience_level') {
          if (d.items !== undefined && d.items !== null) {
            d.items.map(function (record) {
              if (record.key) {
                const experience_list = record.key.split(',');
                experience_list.map(function (experience) {
                  experience = experience.trim();
                  if (!final_experience_list.includes(experience)) {
                    final_experience_list.push(experience);
                  }
                });
                // tmp_experience_level.push({value : record.key, label : record.key, job_count : record.doc_count});
              }
            });
          }
        }

        if (d.type === 'department') {
          if (d.items !== undefined && d.items !== null) {
            d.items.map(function (record) {
              if (record.key) {
                if (!final_department_list.includes(record.key.trim())) {
                  final_department_list.push(record.key.trim());
                }
                // tmp_department.push({value : record.key, label : record.key, job_count : record.doc_count});
              }
            });
          }
        }

        if (d.type === 'contract_type') {
          if (d.items !== undefined && d.items !== null) {
            d.items.map(function (record) {
              if (record.key) {
                const contract_list = record.key.split(',');
                contract_list.map(function (contract) {
                  contract = contract.trim();
                  if (!final_contract_list.includes(contract)) {
                    final_contract_list.push(contract);
                  }
                });
                // tmp_contract_type.push({value : record.key, label : record.key, job_count : record.doc_count});
              }
            });
          }
        }

        if (d.type === 'sbu') {
          if (d.items !== undefined && d.items !== null) {
            d.items.map(function (record) {
              if (record.key) {
                if (!final_sbu_list.includes(record.key.trim())) {
                  final_sbu_list.push(record.key.trim());
                }
                // tmp_sbu.push({value : record.key, label : record.key, job_count : record.doc_count});
              }
            });
          }
        }

        if (d.type === 'professional_communities') {
          if (d.items !== undefined && d.items !== null) {
            d.items.map(function (record) {
              if (record.key) {
                const professional_list = record.key.split(',');
                professional_list.map(function (professional) {
                  professional = professional.trim();
                  if (!final_professional_list.includes(professional)) {
                    final_professional_list.push(professional);
                  }
                });
              }
            });
          }
        }

        if (d.type === 'brand') {
          if (d.items !== undefined && d.items !== null) {
            d.items.map(function (record) {
              if (record.key) {
                if (!final_brand_list.includes(record.key.trim())) {
                  final_brand_list.push(record.key.trim());
                }
                // tmp_sbu.push({value : record.key, label : record.key, job_count : record.doc_count});
              }
            });
          }
        }
      });
    }

    final_country_list.sort((a, b) => a.label.localeCompare(b.label));
    final_country_list.map(function (country) {
      tmp_country_code.push({ value: country.value, label: country.label });
    });

    final_loction_list.sort((a, b) => a.localeCompare(b));
    final_loction_list.map(function (location) {
      tmp_location.push({ value: location, label: location });
    });

    final_experience_list.sort((a, b) => a.localeCompare(b));
    final_experience_list.map(function (experience) {
      if (!isNaN('+' + experience[0])) {
        tmp_experience_level1.push({ value: experience, label: experience });
      } else {
        tmp_experience_level.push({ value: experience, label: experience });
      }
    });

    tmp_experience_level1.sort((a, b) => parseInt(a.value.replace(/,/g, '')) - parseInt(b.value.replace(/,/g, '')));

    tmp_experience_level1.map(function (experience) {
      tmp_experience_level.push({ value: experience.value, label: experience.label });
    });

    final_department_list.sort((a, b) => a.localeCompare(b));
    final_department_list.map(function (department) {
      tmp_department.push({ value: department, label: department });
    });

    final_contract_list.sort((a, b) => a.localeCompare(b));
    final_contract_list.map(function (contract) {
      tmp_contract_type.push({ value: contract, label: contract });
    });

    final_sbu_list.sort((a, b) => a.localeCompare(b));
    final_sbu_list.map(function (sbu) {
      tmp_sbu.push({ value: sbu, label: sbu });
    });

    final_professional_list.sort((a, b) => a.localeCompare(b));
    final_professional_list.map(function (professional_community) {
      tmp_professional_communities.push({ value: professional_community, label: professional_community });
    });

    final_brand_list.sort((a, b) => a.localeCompare(b));
    final_brand_list.map(function (brand) {
      tmp_brand.push({ value: brand, label: brand });
    });

    if (pathName === 'ca-fr') {
      tmp_country_code.push({ value: 'ca-fr', label: 'Canada French' });
      tmp_country_code.push({ value: 'ca-en', label: 'Canada English' });
    }

    if (pathName === 'fr-fr') {
      tmp_country_code.push({ value: 'fr-fr', label: 'France' });
      tmp_country_code.push({ value: 'tn-fr', label: 'Tunisia' });
    }

    this.setState({
      countries: tmp_country_code
    });

    this.setState({
      location: tmp_location
    });

    this.setState({
      experiencelevel: tmp_experience_level
    });

    this.setState({
      departments: tmp_department
    });

    this.setState({
      contracttype: tmp_contract_type
    });

    this.setState({
      businessunits: tmp_sbu
    });

    this.setState({
      professionalcommunities: tmp_professional_communities
    });

    this.setState({
      brands: tmp_brand
    });
  };
  */

  fetchAllData = async (queryStringData) => {
    await this.fetchJobs(queryStringData.keyword, queryStringData.country_code, queryStringData.country_name, queryStringData.experience_level, queryStringData.department, queryStringData.contract_type, queryStringData.sbu, queryStringData.location, queryStringData.brand, queryStringData.professional_communities, queryStringData.size);

    // fetching unique API data
    await this.fetchUniqueData();
  };

  onSearch = async (keyword, countryCode, countryName, experience_level, department, contract_type, business_units, location, brand, professional_communities, size) => {
    console.log('search running');
    if (keyword !== null && keyword !== undefined && keyword !== '') {
      this.setState({ keyword });
      try {
        const size = Number(this.state.size);
        const page = size ? Number(size) / 15 : 1;
        if (keyword) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'internal_search_result.display',
            ise_keyword: keyword,
            ise_page: page,
            ise_engine: 'job_search'
          });
        }
      } catch (e) {
        console.log(e);
      }
    }
    await this.fetchJobs(keyword, countryCode, countryName, experience_level, department, contract_type, business_units, location, brand, professional_communities, size);
    this.setState({ searched: true }, this.scrollToResults);
  };

  scrollToResults = () => {
    let keyword;
    const urlParams = new URLSearchParams(window.location.search); // phpcs:ignore
    const myParam = urlParams.get('keyword');
    if (myParam) {
      keyword = decodeURIComponent(myParam);
    }
    if (keyword) {
      // element which needs to be scrolled to
      const element = document.getElementById('anchor');
      // scroll to element
      element.scrollIntoView();
    }
  };

  checkForExternalSearch = async () => {
    if (document.getElementById('hidden_keyword') !== undefined && document.getElementById('hidden_keyword') !== null) {
      const hidden_keyword = document.getElementById('hidden_keyword').value;
      if (hidden_keyword !== undefined && hidden_keyword !== '') {
        this.onSearch(hidden_keyword);
      }
    }
  };

  render () {
    const filtersdata = (`${window.get_filter_data}`) != '' ? (`${window.get_filter_data}`).split(',') : ['country', 'experience_level', 'department', 'contract_type', 'business_units'];
    const filtercolumnselections = (`${window.get_column_selections}`) != '' ? (`${window.get_column_selections}`).split(',') : ['job_name', 'location', 'experience_level', 'department', 'contract_type', 'business_units'];

    return (
      <section>
        <Search onSearch={this.onSearch} jobs={this.state.jobs} countries={this.state.countries} locations={this.state.location} experiencelevel={this.state.experiencelevel} department={this.state.departments} contracttype={this.state.contracttype} businessunits={this.state.businessunits} brand={this.state.brands} professionalcommunities={this.state.professionalcommunities} filtersdata={filtersdata} />

        {!this.state.jobs || this.state.isErrored
          ? (
            <div className="container alert alert-info mt-3 mb-3 text-center" role="alert">
              { __('Due to maintenance no jobs are currently available.  Please check back later.', 'macs-react-jobs') }
            </div>
            )
          : (
            <div>{
                  (
                    (this.state.jobs).length === 0)
                    ? (
                        <div></div>
                      )
                    : [
                        (
                          (this.state.jobs.data).length === 0)
                          ? (
                              <NoJobs keyword={this.state.keyword}/>
                            )
                          : (
                        <React.Fragment>
                            <div className="content">
                                <div className="section section--search-results section--jobsearch-content">
                                    <div className="container">
                                        {/*
                      <div class="content-title">
                        <h2>
                          <b>{this.state.jobs.total}</b> { __( 'open positions', 'macs-react-jobs' ) }
                        </h2>
                      </div>
                    */}
                                        <div className="filters filters--table">
                                            <JobList jobs={this.state.jobs.data}
                                                     filtercolumnselections={filtercolumnselections}/>

                                            {
                                                (this.state.size < this.state.jobs.total) &&
                                                <div className="filters-bottom">
                                                    <LoadMoreButton loadMore={this.loadMore}/>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </React.Fragment>
                            )
                      ]}
            </div>
            )}
      </section>
    );
  }
}

export default App;
